angular.module('wbControllers').controller 'TumblerController',

['$scope', '$location', ($scope, $location) ->
  $scope.page = $location.search().step or 'province'

  $scope.forward = (page) ->
    $scope.direction = 'forward'
    $scope.page = page
    $location.search({ step: $scope.page }).replace()

  $scope.back = (page) ->
    $scope.direction = 'back'
    $scope.page = page
    $location.search({ step: $scope.page }).replace()
]
